import { defineComponent as _defineComponent } from 'vue'
import { WEB_LOCALES_EMOJIS, LANG_COUNTRY_MAPPING } from '@/constants/web-locales.constant';

import { useLanguageStore } from '@/helpers/composables/useStores';
import { computed } from 'vue';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlagSwitcher',
  emits: ['switcherClick'],
  setup(__props) {



const { language, webLocale, audioLanguage } = useLanguageStore();

const countryFlag = computed(() => WEB_LOCALES_EMOJIS?.[webLocale.value] ?? null);

const languageFlag = computed(() => WEB_LOCALES_EMOJIS?.[LANG_COUNTRY_MAPPING[language.value]] ?? null);

const audioLanguageFlag = computed(() => WEB_LOCALES_EMOJIS?.[LANG_COUNTRY_MAPPING[audioLanguage.value]] ?? null);

const slotData = computed(() => ({
	country: webLocale.value,
	countryFlag: countryFlag.value,
	language: language.value,
	languageFlag: languageFlag.value,
	audioLanguage: audioLanguage.value,
	audioLanguageFlag: audioLanguageFlag.value,
}));

return { __sfc: true,language, webLocale, audioLanguage, countryFlag, languageFlag, audioLanguageFlag, slotData, faAngleDown }
}

})